import React from "react";

import { Flex } from "antd";
import i18next from "i18next";

import { BSCoreServicesDtoMarketplaceOrderTotalDto } from "api/reactQuery/querySchemas";
import Card from "components/Card/Card";

const OrderTotals: React.FC<{
  totals: BSCoreServicesDtoMarketplaceOrderTotalDto;
  isTruckAreaFactorInLimit?: boolean;
  isTotalWeightInLimit?: boolean;
}> = ({ totals, isTruckAreaFactorInLimit, isTotalWeightInLimit }) => {
  return (
    <Flex
      vertical
      style={{ marginLeft: -16, marginRight: -16, width: "calc(100% + 32px)" }}
    >
      <Flex style={{ width: "100%" }} justify="space-between">
        <Card
          title={i18next.t("ttl_truck_area_factor")}
          hasError={
            isTruckAreaFactorInLimit === undefined
              ? false
              : !isTruckAreaFactorInLimit
          }
          value={totals.ttlTruckAreaFactor}
          isBlueCard
        />
        <Card title={i18next.t("ttl_pallets")} value={totals.ttlPallets} />
        <Card
          title={i18next.t("ttl_pallet_count_industrial")}
          value={totals.ttlPalletCountBasketAndIndustrialType}
        />
        <Card
          title={i18next.t("ttl_pallet_count_licensed")}
          value={totals.ttlPalletCountLicensedType}
        />
        <Card
          title={i18next.t("ttl_weight_limit")}
          hasError={
            isTotalWeightInLimit === undefined ? false : !isTotalWeightInLimit
          }
          value={totals.ttlWeight}
          isBlueCard
        />
      </Flex>
      <Flex style={{ marginTop: 8, width: "100%" }} justify="space-between">
        <Card
          title={i18next.t("ttl_volume_in_hl")}
          value={totals.ttlVolumeInHL}
        />
        <Card
          title={i18next.t("ttl_beer_cost_wt_vat_in_bgn")}
          value={totals.ttlBeerCostWithoutVAT}
        />
        <Card
          title={i18next.t("ttl_beer_cost_w_vat_in_bgn")}
          value={totals.ttlBeerCostWithVAT}
          isBlueCard
        />
        <Card
          title={i18next.t("ttl_packaging_cost_in_bgn")}
          value={totals.ttlPackagingCost}
        />
        <Card
          title={i18next.t("ttl_beer_w_vat_packaging_cost_in_bgn")}
          value={totals.ttlBeerWithVATAndPackagingCost}
        />
      </Flex>
    </Flex>
  );
};
export default OrderTotals;
